import ScrollToTop from './ScrollToTop';
import StartPage from './StartPage';
import Admin from './admin';
import InfoPage from './components/info/InfoPage';
import PrivacyPolicyPopup from './components/info/PrivacyPolicyPopup';
import PrivacyPolicy from './components/info/PrivacyPolicy';
import Rules from './components/info/Rules';
import './css/app.css';
import {Routes,Route} from "react-router-dom"
import Transparency from './components/info/Transparency';
import AboutMe from './components/info/AboutMe';
import CoffeePage from './components/info/CoffeePage';
import WeatherPage from './components/weather/WeatherPage';
import CurrentAltitude from './components/wysokosciomierz/wysokosciomierz';
import HowItWorks from './components/info/HowItWorks';
import { AvalancheContext } from './components/context/AvalancheContext';
import AdminPanel from './components/AdminPanel';
import { useState } from 'react';


function App() {

  const [level, setLevel] = useState('');

  return (
    <>

  
<AvalancheContext.Provider value={{ level, setLevel }}>

      <ScrollToTop />      
      <Routes>
        <Route path='/' element={<StartPage />} />
        <Route path='/admin' element={<Admin />} />
        <Route path='/pogoda' element={<WeatherPage />}/>
        <Route path='/wysokosciomierz' element={<CurrentAltitude />}/>
        <Route path='/info' element={<InfoPage />}/>
        <Route path='/info/o-mnie' element={<AboutMe />} />
        <Route path='/info/postaw-kawe' element={<CoffeePage />} />
        <Route path='/info/jaktodziała' element={<HowItWorks />} />
        <Route path='/info/regulamin' element={<Rules />} />
        <Route path='/info/polityka-prywatnosci-popup' element={<PrivacyPolicyPopup />} />
        <Route path='/info/polityka-prywatnosci' element={<PrivacyPolicy />} />
        <Route path='/info/transparetnosc' element={<Transparency />} />
      </Routes>

    </AvalancheContext.Provider>
    </>
  );
}

export default App;